import API from 'services/TAPS_API';

export default function getDocumentTypes(docTypeId) {
  return API.request({
    method: 'GET',
    url: docTypeId ? `/dictionary/id-doc-type/${docTypeId}` : `/dictionary/id-doc-type`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
